/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateIntegrationRequest } from '../../models/create-integration-request';
import { CreateIntegrationResponse } from '../../models/create-integration-response';

export interface InitIntegration$Params {
      body: CreateIntegrationRequest
}

export function initIntegration(http: HttpClient, rootUrl: string, params: InitIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateIntegrationResponse>> {
  const rb = new RequestBuilder(rootUrl, initIntegration.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateIntegrationResponse>;
    })
  );
}

initIntegration.PATH = '/integrations';
